import { httpClient } from './httpClient';

export const loginCompany = async (email, password) => {
  const response = await httpClient.post(`/company/login`, { email, password });
  return response.data;
};

export const createCompany = async (companyName) => {
  const response = await httpClient.post(`/companies/store`, {
    company_name: companyName,
  });
  return response.data;
};

export const fetchCompanyUsers = async () => {
  const response = await httpClient.get(`/companies/users`);
  return response.data;
};
